<template>
	<div class="edit">
		<monthly-product-editor
			:mode="mode"
			:item-id="itemId"
			@submit="onSubmit"
		/>
	</div>
</template>
<script>
	import MonthlyProductEditor from '@/components/product/MonthlyProductEditor';

	export default {
		name: 'MonthlyProductEdit',
		components: {
			MonthlyProductEditor,
		},
		data() {
			return {
				mode: 'register',
				itemId: null,
			};
		},
		mounted() {
			this.mode =
				this.$route.name === 'MonthlyProductRegister'
					? 'register'
					: 'edit';
			this.itemId = Number(this.$route.params.itemId) || null;
		},
		methods: {
			onSubmit(args) {
				const params = {
					...args,
				};

				if (this.mode === 'edit') {
					params.idMonthlyProduct = this.itemId;
				}

				this.$axiosAdmin2
					.post('/api/products/monthly', params)
					.then(() => {
						const query = this.$route.query.back
							? JSON.parse(
									decodeURIComponent(
										atob(this.$route.query.back)
									)
								)
							: {};
						alert('저장되었습니다.');

						this.$router.push({
							query,
							path: '/advertisement/monthly-product',
						});
					})
					.catch(err => {
						console.error(err);
						alert(
							'저장 중 문제가 발생했습니다.\n문제가 반복될 시 개발팀에 문의해 주세요'
						);
					});
			},
		},
	};
</script>
<style lang="scss" scoped></style>
